import { render, staticRenderFns } from "./FormAudio.vue?vue&type=template&id=98c9726c&"
import script from "./FormAudio.vue?vue&type=script&lang=js&"
export * from "./FormAudio.vue?vue&type=script&lang=js&"
import style0 from "./FormAudio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports